import {
    PAGE_SUBMIT_BEGIN,
    PAGE_SUBMIT_SUCCESS,
    PAGE_SUBMIT_FAIL
  } from '../middleware/types'
  
  const initialState = {
    ACTION_loading: false,
    error: {},
    response : {}
  }

  export default (state = initialState, action) => {
    switch (action.type) {
      case PAGE_SUBMIT_BEGIN:
        return {
          ...state,
          ACTION_loading: true
        }
      case PAGE_SUBMIT_SUCCESS:
          return {
              ...state,
              ACTION_loading: false,
              response: {
                ...action.payload
              }
          }
      case PAGE_SUBMIT_FAIL:
        return {
          ...state,
          ACTION_loading: false,
          error: action.payload
        }
      default:
        return state
    }
  }